import React from "react";

function FacebookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#1877F2"
        d="M24.625 12.66c0 6.062-4.493 11.074-10.329 11.887a12.161 12.161 0 01-3.593-.038C4.99 23.59.625 18.633.625 12.66c0-6.63 5.373-12.004 12-12.004 6.626 0 12 5.375 12 12.004z"
      ></path>
      <path
        fill="#fff"
        d="M14.296 10.294v2.614h3.234l-.512 3.523h-2.722v8.116a12.16 12.16 0 01-3.593-.038V16.43H7.721v-3.523h2.982V9.71a3.594 3.594 0 013.594-3.595v.002l.017-.002h3.217v3.047h-2.102c-.625 0-1.132.507-1.132 1.132h-.001z"
      ></path>
    </svg>
  );
}

export default FacebookIcon;
